import { EntityLinks, Goal, ID } from '@griply/types';

import { getGoalParentIds } from './goals/get-goal-parents';

export type GetGoalAncestorsOptions = {
  links?: EntityLinks;
};

// The primary ancestor path, root-first. A goal with several parents has several paths;
// this follows the first, which is what a single-line breadcrumb can render.
export const getGoalAncestors = (
  goal: Goal,
  goals: Goal[],
  { links }: GetGoalAncestorsOptions = {},
): Goal[] => {
  const goalsMap = new Map(goals.map((g) => [g.id, g]));
  const visited = new Set<ID>([goal.id]);

  const walk = (current: Goal): Goal[] => {
    const [parentId] = getGoalParentIds(current, { links });
    if (!parentId) {
      return [];
    }
    const parent = goalsMap.get(parentId);
    if (!parent || visited.has(parent.id)) {
      return [];
    }
    visited.add(parent.id);
    return [...walk(parent), parent];
  };

  return walk(goal);
};
